import { render, staticRenderFns } from "./NationalityStatus.vue?vue&type=template&id=0c7a5ff6"
import script from "./NationalityStatus.vue?vue&type=script&lang=js"
export * from "./NationalityStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports